import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { PershingError, ServiceRouter, LogService } from '@pershing/pershing-core';
import { Content } from '../models/content.model';
import { ContentManagementServiceDefinition } from './content-management-service-definition';

let headers = new HttpHeaders({
    'Content-Type':  'application/json'
});

@Injectable()
export class ContentManagementService {
    content$: Observable<Content>;
    error$: Observable<PershingError>;
    private _content: BehaviorSubject<Content>;
    private _error: BehaviorSubject<PershingError>;
    private baseUrl: string;
    private dataStore: {
        content: Content
    };

    constructor(private serviceRouter: ServiceRouter, private logService: LogService, private http: HttpClient) {
        this._error = new BehaviorSubject<PershingError>(null);
        this.error$ = this._error.asObservable();
        this.dataStore = { content: null };
        this._content = <BehaviorSubject<Content>>new BehaviorSubject(null);
        this.content$ = this._content.asObservable();
        this.baseUrl = this.serviceRouter.getServiceRouteURL(ContentManagementServiceDefinition.getInstance(), { ignoreOptions: { serviceVersion: true } });
       // this.baseUrl = 'http://localhost:8080/webcontent';
        console.log('baseURL', this.baseUrl);
    }

    /**
     * Gets an Observable of type HttpResponse<any> (or) Observable<null> when making the request for preferences.
     * ** catch block is used primarily for observable stream continuation in case of errors during http call
     * @return Observable<HttpResponse<any>> | Observable<{}}>
     */
    retrieveContent(communityName: string, articleId: string, themeType: string, siteName: string, language: string): Observable<any> {

        return  this.http.post(`${this.baseUrl}/${communityName}/${articleId}/${themeType}/${siteName}/${language}`, { headers: headers } );
    }

    setError(errorMessage: string, errorCode?: string): void {
        this._error.next(new PershingError(errorMessage, 'contentService', errorCode));
    }
}
